<template>
  <div>
    <div class="banner">
      <div class="headerReplacementStockPriceInfo"></div>
      <div class="banner-text">
        <b>{{ $t('stockPriceInfo.pageTitle') }}</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">{{ $t('stockPriceInfo.breadcrumbHome') }}</router-link></span>
          <span class="separator"></span>
          <span>{{ $t('stockPriceInfo.breadcrumbCurrent') }}</span>
          <span class="separator"></span>
          <span><b>{{ $t('stockPriceInfo.breadcrumbTitle') }}</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- Loading Spinner -->
      <div v-if="isLoading" class="d-flex justify-content-center align-items-center mb-5" style="height: 50px;">
        <div class="spinner-grow custom-spinner" role="status"></div>
      </div>

      <div v-if="list.length > 0" class="card bg-white mt-4 mb-5 p-0">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-2 mb-1 p-0">
              <div class="info-box mb-2">
                <div class="info-text bg-text-symbol text-white p-2 rounded-top">SET: {{ list[0].symbol }}</div>
                <div class="info-text bg-text text-white p-2 rounded-bottom">
                  {{ formatLastTwoDecimal(list[0].last || '-') }} {{ $t('stockPriceInfo.currency') }}
                </div>
              </div>
            </div>

            <div class="col-md-6 border-stock text-center">
              <div class="info-box">
                <p class="info-text">{{ $t('stockPriceInfo.volume') }}</p>
                <h6 class="info-title">{{ formatNumber(list[0].totalVolume) }}</h6>
              </div>
            </div>

            <div class="col-md-2 border-stock text-center">
              <div class="info-box">
                <p class="info-text">{{ $t('stockPriceInfo.prior') }}</p>
                <h6 class="info-title">{{ formatLastTwoDecimal(list[0].prior) }}</h6>
              </div>
            </div>

            <div class="col-md-2 border-stock-end text-center">
              <div class="info-box">
                <p class="info-text">{{ $t('stockPriceInfo.open') }}</p>
                <h6 class="info-title">{{ formatLastTwoDecimal(list[0].open) }}</h6>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 border-stock-start bg-updated">
              <div class="info-box text-center">
                <p class="info-text-price mt-1">{{ $t('stockPriceInfo.change') }}</p>
                <p class="info-text-price">
                  <b>
                    <p class="text-title m-0" v-if="list[0].time" :class="changeClass(list[0].last, list[0].prior)">
                      {{ calculateChange(list[0].last, list[0].prior) }} ({{ calculatePercentageChange(list[0].last, list[0].prior) }}%)
                    </p>
                  </b>
                </p>
                <p v-if="list[0].time" class="info-text-price">{{ $t('stockPriceInfo.updated') }}</p>
                <p v-if="list[0].time" class="info-text-price mb-2">{{ formatDate(list[0].time) }}</p>
              </div>
            </div>

            <div class="col-md-3 mb-3 border-stock-start text-center">
              <div class="info-box">
                <p class="info-text mt-2">{{ $t('stockPriceInfo.offerVolume') }}</p>
                <h6 class="info-title">
                  {{ formatLastTwoDecimal(list[0].last) }} /
                  {{ formatNumber(bid[0]?.volume) || '-' }}
                </h6>
              </div>
            </div>

            <div class="col-md-3 mb-3 border-stock-start text-center">
              <div class="info-box">
                <p class="info-text mt-2">{{ $t('stockPriceInfo.bidVolume') }}</p>
                <h6 class="info-title">
                  {{ formatLastTwoDecimal(list[0].high) }} /
                  {{ formatNumber(offer[0]?.volume) || '-' }}
                </h6>
              </div>
            </div>

            <div class="col-md-4 mb-3 text-center">
              <div class="info-box">
                <p class="info-text mt-2">{{ $t('stockPriceInfo.dayRange') }}</p>
                <h6 class="info-title">
                  {{ formatLastTwoDecimal(list[0].low) }} - {{ formatLastTwoDecimal(list[0].high) }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chart can be placed here if needed -->
    </div>
  </div>
</template>


<script>
import StockPriceInfoTabMenu from '@/components/StockPriceInfoTabMenu.vue';
import Highcharts from 'highcharts/highstock';
import store from "@/store";
import { mapState } from "vuex";
import { GET_SET_STOCK_QUOTATION_DATA } from "../../store/actions.type";
import dayjs from 'dayjs';

export default {
  name: 'Info',
  components: {
    StockPriceInfoTabMenu,
  },
  data() {
    return {
      list: [],
      Percentagechange: "",
      change: "",
      stockData: [
        [Date.UTC(2023, 9, 1, 9, 0), 5.95],
        [Date.UTC(2023, 9, 1, 10, 0), 6.05],
        [Date.UTC(2023, 9, 1, 11, 0), 6.15],
        [Date.UTC(2023, 9, 1, 12, 0), 6.08],
        [Date.UTC(2023, 9, 1, 13, 0), 6.12],
        [Date.UTC(2023, 9, 1, 14, 0), 6.10],
        [Date.UTC(2023, 9, 1, 15, 0), 6.05],
      ],
      bid: "",
      offer: "",
      isLoading: false,

    };
  },
  async created() {
    this.isLoading = true;
    await this.init();
    this.isLoading = false;
  },
  mounted() {
    Highcharts.stockChart(this.$refs.chartContainer, {
      title: {
        text: 'AAPL stock price by minute'
      },
      subtitle: {
        text: 'Using ordinal X axis'
      },
      xAxis: {
        gapGridLineWidth: 0
      },
      rangeSelector: {
        buttons: [{
          type: 'hour',
          count: 1,
          text: '1h'
        }, {
          type: 'day',
          count: 1,
          text: '1D'
        }, {
          type: 'all',
          count: 1,
          text: 'All'
        }],
        selected: 1,
        inputEnabled: false
      },
      series: [{
        name: 'AAPL',
        type: 'area',
        data: this.stockData,
        gapSize: 5,
        tooltip: {
          valueDecimals: 2
        },
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, Highcharts.getOptions().colors[0]],
            [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
          ]
        },
        threshold: null
      }]
    });
  },
  methods: {
    async init() {
      this.list = await store.dispatch(GET_SET_STOCK_QUOTATION_DATA);

      this.bid = this.list[0].bid
      this.offer = this.list[0].offer
    },

    formatDate(dateString) {
      return dayjs(dateString).format('DD MMMM YYYY, hh:mm:ss');
    },
    calculateChange(last, prior) {
      const change = (last - prior).toFixed(2);
      return change;
    },
    calculatePercentageChange(last, prior) {
      if (prior === 0) return 0;
      const Percentagechange = ((last - prior) / prior) * 100;
      return Percentagechange.toFixed(2);
    },
    formatNumber(number) {
      return number.toLocaleString();
    },
    formatLastTwoDecimal(price) {
      return price ? price.toFixed(2) : "-";
    },
    changeClass(last, prior) {
      const change = last - prior;
      if (change > 0) {
        return 'text-success';
      } else if (change < 0) {
        return 'text-danger';
      }
      return '';
    },
    goToStockPriceInfo() {
      this.$router.push('/stockpriceinfo/info');
    },
    redirectToFactSheet() {
      window.open('https://www.set.or.th/th/market/product/stock/quote/ori/factsheet', '_blank');
    }
  }
};
</script>
<style scoped>
.border-stock-start {
  border-bottom: transparent;
  border-right: 1px solid #ddd;
  ;
  border-top: transparent;
  align-self: center;
}

.border-stock-end {
  border-bottom: 1px solid #ddd;
  border-right: transparent;
  border-top: transparent;
  align-self: center;
}

.border-stock {
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  border-top: transparent;
  align-self: center;
}

@media (max-width: 767px) {
  .border-stock {
    border-bottom: 1px solid #ddd;
    border-right: transparent;
  }
}

@media (max-width: 767px) {
  .border-stock-start {
    border-bottom: 1px solid #ddd;
    border-right: transparent;
  }
}

th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}

.card {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 8px;
}

.card-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
}

.card-text {
  color: #666;
}

.btn-primary {
  background-color: #E87D2E;
  border: none;
}

.btn-primary:hover {
  background-color: #d97328;
}

.info-title {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 25px;
}

.info-text {
  font-size: 0.875rem;
  color: #666;
}

.info-text-price {
  font-size: 0.675rem;
  margin: 0;
}

.bg-black {
  background-color: #000;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  display: inline-block;
}

.bg-text-symbol {
  background-color: #000000;
  font-size: 20px;
}

.bg-text {
  background-color: #E87D2E;
  font-size: 23px;
  font-weight: bold;
}
</style>




